/** v90 uppercase field labels — matches auth signup screens. */
export const fieldLabelStyle = { textTransform: 'uppercase', letterSpacing: '0.08em' } as const;

/** v90 mono counter (spots, bio) — uses theme code font token. */
export const monoCounterStyle = {
  fontFamily: 'var(--code-font-family)',
  letterSpacing: '0.04em',
} as const;
